import React from 'react';
import { IconProps } from '../types';
import styles from '../Icons.module.scss';
import { getSvgDimensions } from '../utils';
import { DEFAULT_ICON_SIZE } from '../constants';

const SmsIconOutlined: React.FC<IconProps> = ({
    size = DEFAULT_ICON_SIZE,
    width,
    height,
    color = styles.naviIconDefaultColor,
    ...restProps
}) => {
    const { svgHeight, svgWidth } = getSvgDimensions({ height, width, size });

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={svgWidth}
            height={svgHeight}
            fill="none"
            viewBox="0 0 24 24"
            {...restProps}
        >
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M20.667 18h-9.334L6 22v-4H3.333A1.334 1.334 0 012 16.667V3.333A1.333 1.333 0 013.333 2h17.334A1.333 1.333 0 0122 3.333v13.334A1.334 1.334 0 0120.667 18z"
            ></path>
        </svg>
    );
};

export default React.memo(SmsIconOutlined);
